export const shadows = {
  low: '0px 2px 8px rgba(106, 115, 129, 0.12)',
  medium:
    '0px 6px 12px rgba(106, 115, 129, 0.16), 0px 3px 8px rgba(87, 102, 117, 0.06)',
  high: '0px 12px 20px rgba(106, 115, 129, 0.22)',
  top: '0px 4px 16px rgba(0, 0, 0, 0.25)',
  left: '-1px 2px 8px rgba(106, 115, 129, 0.22)',
  right: '1px 0px 8px rgba(106, 115, 129, 0.22)',
};
